var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchMain = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9.75C18 14.3063 14.3063 18 9.75 18C5.19365 18 1.5 14.3063 1.5 9.75C1.5 5.19365 5.19365 1.5 9.75 1.5C14.3063 1.5 18 5.19365 18 9.75ZM14.8681 18.0502C13.3805 18.9695 11.6272 19.5 9.75 19.5C4.36522 19.5 0 15.1348 0 9.75C0 4.36522 4.36522 0 9.75 0C15.1348 0 19.5 4.36522 19.5 9.75C19.5 11.6273 18.9695 13.3806 18.0501 14.8683L23.6517 20.4698C23.9445 20.7627 23.9445 21.2376 23.6517 21.5305L21.5303 23.6518C21.2374 23.9447 20.7626 23.9447 20.4697 23.6518L14.8681 18.0502ZM16.0936 17.1544L21 22.0608L22.0607 21.0001L17.1542 16.0937C16.8283 16.4738 16.4736 16.8285 16.0936 17.1544Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchMain);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search-main.0d87403469876f8fec3ed764dfebd984.svg";